export interface WeatherData {
  temperature: number | null;
  humidity: number | null;
  season: string;
  recommendation: string;
}

export async function getWeatherRecommendation(
  lat?: number,
  lon?: number
): Promise<WeatherData> {
  try {
    const latitude = lat ?? 51.5; // Default to London
    const longitude = lon ?? -0.1;
    
    const url = `https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&current_weather=true&hourly=relativehumidity_2m`;
    
    // Add timeout to prevent hanging
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 second timeout
    
    const res = await fetch(url, { 
      signal: controller.signal,
      headers: {
        'Accept': 'application/json',
      }
    });
    
    clearTimeout(timeoutId);
    
    if (!res.ok) {
      throw new Error(`Weather API returned ${res.status}: ${res.statusText}`);
    }
    
    const json = await res.json();

    const temp = json.current_weather?.temperature ?? null;
    const humidity = json.hourly?.relativehumidity_2m?.[0] ?? null;

    let recommendation = "Balanced blend";
    if (temp !== null) {
      if (temp < 10) {
        recommendation = "Rich, smoky blend for cold weather.";
      } else if (temp > 25) {
        recommendation = "Light, aromatic smoke for warm weather.";
      }
    }
    if (humidity !== null && humidity > 80) {
      recommendation += " Avoid overly moist tobaccos.";
    }

    // Determine season
    const now = new Date();
    const month = now.getMonth() + 1;
    let season = "Autumn";
    if (month <= 2 || month === 12) season = "Winter";
    else if (month <= 5) season = "Spring";
    else if (month <= 8) season = "Summer";

    return {
      temperature: temp,
      humidity,
      season,
      recommendation,
    };
  } catch (error) {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Weather API timeout - using fallback data');
    } else {
      console.error('Weather API error:', error);
    }
    return {
      temperature: null,
      humidity: null,
      season: "Unknown",
      recommendation: "Unable to fetch weather. Choose any blend you enjoy!",
    };
  }
}

